import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { clearAll, getValidSession } from '../../pages/helpers/sessionUtils';
import { buildVendorProfileUrl } from '../../utils/vendorProfileUrl';
import apiClient from '../../api/apiClient';
import VendorVerificationBadge from '../../components/common/VendorVerificationBadge';

const Header = () => {
    const adminAssetsUrl = `${process.env.PUBLIC_URL}/admin-assets`;
    const navigate = useNavigate();

    const [vendor, setVendor] = useState(null);
    const [kycHistory, setKycHistory] = useState([]);
    const location = useLocation();

    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    useEffect(() => {
        let initialVendor = null;
        if (location.state?.user) {
            initialVendor = location.state.user;
            setVendor(initialVendor);
            localStorage.setItem('userInfo', JSON.stringify(location.state.user));
        } else {
            const storedUser = localStorage.getItem('userInfo');

            if (storedUser) {
                initialVendor = JSON.parse(storedUser);
                setVendor(initialVendor);
            } else {
                const session = getValidSession();
                if (session?.user) {
                    const user = session.user.user || session.user;
                    initialVendor = user;
                    setVendor(user);
                    localStorage.setItem('userInfo', JSON.stringify(user));
                } else {
                    console.warn("No user data found in route or storage.");
                }
            }
        }

        if (initialVendor?.id) {
            apiClient.get(`/vendors/${initialVendor.id}/details`)
                .then(({ data }) => {
                    if (data.user) {
                        setVendor(data.user);
                        setKycHistory(data.kycHistory || []);
                        localStorage.setItem('userInfo', JSON.stringify(data.user));
                    }
                })
                .catch((error) => console.error('Unable to refresh vendor verification status:', error));
        }
    }, [location]);

    const handleLogout = async (e) => {
        e.preventDefault();
        clearAll();
        navigate('/login');
    };

    const toggleMenuBtn = () => {
        console.log("Header Toggle Clicked"); // For debugging
        const windowSize = document.documentElement.clientWidth;
        const html = document.documentElement;
        const body = document.body;

        // Determine and Set Layout Attributes
        if (windowSize > 1199) {
            // Desktop Logic: Toggle between 'lg' (default) and 'sm' (collapsed)
            const currentSize = html.getAttribute("data-sidebar-size");
            const newSize = currentSize === "sm" ? "lg" : "sm";

            html.setAttribute("data-sidebar-size", newSize);

            // Some versions of the theme also use this class on the wrapper or body
            body.classList.remove("vertical-sidebar-enable");
        } else {
            // Mobile Logic: Toggle the sidebar visibility class
            body.classList.toggle("vertical-sidebar-enable");

            // Ensure size is set to large so it's readable when it slides in
            html.setAttribute("data-sidebar-size", "lg");
        }
    };



    const toggleFullscreen = () => {
        if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen();
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            } else if (document.exitFullscreen) {
                document.exitFullscreen();
            }
        }
    };

    const toggleDarkMode = () => {
        const currentMode = document.documentElement.getAttribute('data-layout-mode') || 'light';
        const newMode = currentMode === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-layout-mode', newMode);
        document.documentElement.setAttribute('data-bs-theme', newMode);
    };

    const vendorPreviewUrl = buildVendorProfileUrl(vendor);

    const handlePendingVerificationClick = (check) => {
        const destinationByCheck = {
            gst: ['/admin/kyc-verification', 'business'],
            kyc: ['/admin/kyc-verification', 'personal'],
            logo: ['/admin/profile-setup', 'media'],
            banner: ['/admin/profile-setup', 'media'],
            categories: ['/admin/profile-setup', 'categories']
        };
        const destination = destinationByCheck[check.key];
        if (destination) {
            navigate(`${destination[0]}?tab=${destination[1]}`, { state: { activeTabKey: destination[1] } });
        }
    };

    return (
        <header id="page-topbar">
            <div className="layout-width">
                <div className="navbar-header">
                    <div className="d-flex vendor-header-start">
                        <div className="navbar-brand-box horizontal-logo">
                            <Link to="/admin/dashboard" className="logo logo-dark">
                                <span className="logo-sm">
                                    <img src="/mangoloops-fevicon.png" alt="Mangoloops" height="22" />
                                </span>
                                <span className="logo-lg">
                                    <img src="/logo-mangoloops.png" alt="Mangoloops" height="30" />
                                </span>
                            </Link>
                            <Link to="/admin/dashboard" className="logo logo-light">
                                <span className="logo-sm">
                                    <img src="/mangoloops-fevicon.png" alt="Mangoloops" height="22" />
                                </span>
                                <span className="logo-lg">
                                    <img src="/logo-mangoloops.png" alt="Mangoloops" height="30" />
                                </span>
                            </Link>
                        </div>
                        <button
                            type="button"
                            className="btn btn-sm px-3 fs-22 header-item vertical-menu-btn vendor-menu-toggle shadow-none"
                            id="topnav-hamburger-icon"
                            onClick={toggleMenuBtn}
                            aria-label="Toggle sidebar menu"
                        >
                            <i className="ri-menu-2-line"></i>
                        </button>
                        {/* <form className="app-search d-none d-md-block">
                            <div className="position-relative">
                                <input type="text" className="form-control" placeholder="Search..." autoComplete="off" id="search-options" defaultValue="" />
                                <span className="mdi mdi-magnify search-widget-icon"></span>
                                <span className="mdi mdi-close-circle search-widget-icon search-widget-icon-close d-none" id="search-close-options"></span>
                            </div>
                            <div className="dropdown-menu dropdown-menu-lg" id="search-dropdown">
                                <div data-simplebar style={{ maxHeight: '320px' }}>
                                    <div className="dropdown-header">
                                        <h6 className="text-overflow text-muted mb-0 text-uppercase">Recent Searches</h6>
                                    </div>
                                    <div className="dropdown-item bg-transparent text-wrap">
                                        <a href="#!" className="btn btn-soft-secondary btn-sm rounded-pill">how to setup <i className="mdi mdi-magnify ms-1"></i></a>
                                        <a href="#!" className="btn btn-soft-secondary btn-sm rounded-pill">buttons <i className="mdi mdi-magnify ms-1"></i></a>
                                    </div>
                                    <div className="dropdown-header mt-2">
                                        <h6 className="text-overflow text-muted mb-1 text-uppercase">Pages</h6>
                                    </div>
                                    <a href="#!" className="dropdown-item notify-item">
                                        <i className="ri-bubble-chart-line align-middle fs-18 text-muted me-2"></i>
                                        <span>Analytics Dashboard</span>
                                    </a>
                                    <a href="#!" className="dropdown-item notify-item">
                                        <i className="ri-lifebuoy-line align-middle fs-18 text-muted me-2"></i>
                                        <span>Help Center</span>
                                    </a>
                                    <a href="#!" className="dropdown-item notify-item">
                                        <i className="ri-user-settings-line align-middle fs-18 text-muted me-2"></i>
                                        <span>My account settings</span>
                                    </a>
                                    <div className="dropdown-header mt-2">
                                        <h6 className="text-overflow text-muted mb-2 text-uppercase">Members</h6>
                                    </div>
                                    <div className="notification-list">
                                        <a href="#!" className="dropdown-item notify-item py-2">
                                            <div className="d-flex">
                                                <img src={`${adminAssetsUrl}/images/users/avatar-2.jpg`} className="me-3 rounded-circle avatar-xs" alt="user-pic" />
                                                <div className="flex-grow-1">
                                                    <h6 className="m-0">Angela Bernier</h6>
                                                    <span className="fs-11 mb-0 text-muted">Manager</span>
                                                </div>
                                            </div>
                                        </a>
                                        <a href="#!" className="dropdown-item notify-item py-2">
                                            <div className="d-flex">
                                                <img src={`${adminAssetsUrl}/images/users/avatar-3.jpg`} className="me-3 rounded-circle avatar-xs" alt="user-pic" />
                                                <div className="flex-grow-1">
                                                    <h6 className="m-0">David Grasso</h6>
                                                    <span className="fs-11 mb-0 text-muted">Web Designer</span>
                                                </div>
                                            </div>
                                        </a>
                                        <a href="#!" className="dropdown-item notify-item py-2">
                                            <div className="d-flex">
                                                <img src={`${adminAssetsUrl}/images/users/avatar-5.jpg`} className="me-3 rounded-circle avatar-xs" alt="user-pic" />
                                                <div className="flex-grow-1">
                                                    <h6 className="m-0">Mike Bunch</h6>
                                                    <span className="fs-11 mb-0 text-muted">React Developer</span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div className="text-center pt-3 pb-1">
                                    <Link to="/search-results" className="btn btn-primary btn-sm">View All Results <i className="ri-arrow-right-line ms-1"></i></Link>
                                </div>
                            </div>
                        </form> */}
                    </div>
                    <div className="d-flex align-items-center vendor-header-actions">
                        {vendor && (
                            <VendorVerificationBadge
                                vendor={vendor}
                                kycHistory={kycHistory}
                                className="me-2"
                                onPendingCheckClick={handlePendingVerificationClick}
                            />
                        )}
                        <div className="dropdown d-md-none topbar-head-dropdown header-item">
                            {/* <button type="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none" id="page-header-search-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className="bx bx-search fs-22"></i>
                            </button> */}
                            <div className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" aria-labelledby="page-header-search-dropdown">
                                <form className="p-3">
                                    <div className="form-group m-0">
                                        <div className="input-group">
                                            <input type="text" className="form-control" placeholder="Search ..." aria-label="Recipient's username" />
                                            <button className="btn btn-primary" type="submit"><i className="mdi mdi-magnify"></i></button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {/* <div className="dropdown ms-1 topbar-head-dropdown header-item">
                            <button type="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <img id="header-lang-img" src={`${adminAssetsUrl}/images/flags/us.svg`} alt="Header Language" height="20" className="rounded" />
                            </button>
                            <div className="dropdown-menu dropdown-menu-end">
                                <a href="#!" className="dropdown-item notify-item language py-2" data-lang="en" title="English">
                                    <img src={`${adminAssetsUrl}/images/flags/us.svg`} alt="user-image" className="me-2 rounded" height="18" />
                                    <span className="align-middle">English</span>
                                </a>
                                <a href="#!" className="dropdown-item notify-item language" data-lang="sp" title="Spanish">
                                    <img src={`${adminAssetsUrl}/images/flags/spain.svg`} alt="user-image" className="me-2 rounded" height="18" />
                                    <span className="align-middle">Española</span>
                                </a>
                                <a href="#!" className="dropdown-item notify-item language" data-lang="gr" title="German">
                                    <img src={`${adminAssetsUrl}/images/flags/germany.svg`} alt="user-image" className="me-2 rounded" height="18" /> <span className="align-middle">Deutsche</span>
                                </a>
                                <a href="#!" className="dropdown-item notify-item language" data-lang="it" title="Italian">
                                    <img src={`${adminAssetsUrl}/images/flags/italy.svg`} alt="user-image" className="me-2 rounded" height="18" />
                                    <span className="align-middle">Italiana</span>
                                </a>
                                <a href="#!" className="dropdown-item notify-item language" data-lang="ru" title="Russian">
                                    <img src={`${adminAssetsUrl}/images/flags/russia.svg`} alt="user-image" className="me-2 rounded" height="18" />
                                    <span className="align-middle">русский</span>
                                </a>
                                <a href="#!" className="dropdown-item notify-item language" data-lang="ch" title="Chinese">
                                    <img src={`${adminAssetsUrl}/images/flags/china.svg`} alt="user-image" className="me-2 rounded" height="18" />
                                    <span className="align-middle">中国人</span>
                                </a>
                                <a href="#!" className="dropdown-item notify-item language" data-lang="fr" title="French">
                                    <img src={`${adminAssetsUrl}/images/flags/french.svg`} alt="user-image" className="me-2 rounded" height="18" />
                                    <span className="align-middle">français</span>
                                </a>
                                <a href="#!" className="dropdown-item notify-item language" data-lang="ar" title="Arabic">
                                    <img src={`${adminAssetsUrl}/images/flags/ae.svg`} alt="user-image" className="me-2 rounded" height="18" />
                                    <span className="align-middle">Arabic</span>
                                </a>
                            </div>
                        </div> */}
                        {/* <div className="dropdown topbar-head-dropdown ms-1 header-item">
                            <button type="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i className='bx bx-category-alt fs-22'></i>
                            </button>
                            <div className="dropdown-menu dropdown-menu-lg p-0 dropdown-menu-end">
                                <div className="p-3 border-top-0 border-start-0 border-end-0 border-dashed border">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h6 className="m-0 fw-semibold fs-15"> Web Apps </h6>
                                        </div>
                                        <div className="col-auto">
                                            <a href="#!" className="btn btn-sm btn-soft-info shadow-none"> View All Apps
                                                <i className="ri-arrow-right-s-line align-middle"></i></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="p-2">
                                    <div className="row g-0">
                                        <div className="col">
                                            <a className="dropdown-icon-item" href="#!">
                                                <img src={`${adminAssetsUrl}/images/brands/github.png`} alt="Github" />
                                                <span>GitHub</span>
                                            </a>
                                        </div>
                                        <div className="col">
                                            <a className="dropdown-icon-item" href="#!">
                                                <img src={`${adminAssetsUrl}/images/brands/bitbucket.png`} alt="bitbucket" />
                                                <span>Bitbucket</span>
                                            </a>
                                        </div>
                                        <div className="col">
                                            <a className="dropdown-icon-item" href="#!">
                                                <img src={`${adminAssetsUrl}/images/brands/dribbble.png`} alt="dribbble" />
                                                <span>Dribbble</span>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="row g-0">
                                        <div className="col">
                                            <a className="dropdown-icon-item" href="#!">
                                                <img src={`${adminAssetsUrl}/images/brands/dropbox.png`} alt="dropbox" />
                                                <span>Dropbox</span>
                                            </a>
                                        </div>
                                        <div className="col">
                                            <a className="dropdown-icon-item" href="#!">
                                                <img src={`${adminAssetsUrl}/images/brands/mail_chimp.png`} alt="mail_chimp" />
                                                <span>Mail Chimp</span>
                                            </a>
                                        </div>
                                        <div className="col">
                                            <a className="dropdown-icon-item" href="#!">
                                                <img src={`${adminAssetsUrl}/images/brands/slack.png`} alt="slack" />
                                                <span>Slack</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="dropdown topbar-head-dropdown ms-1 header-item">
                            <button type="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none" id="page-header-cart-dropdown" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-haspopup="true" aria-expanded="false">
                                <i className='bx bx-shopping-bag fs-22'></i>
                                <span className="position-absolute topbar-badge cartitem-badge fs-10 translate-middle badge rounded-pill bg-info">5</span>
                            </button>
                            <div className="dropdown-menu dropdown-menu-xl dropdown-menu-end p-0 dropdown-menu-cart" aria-labelledby="page-header-cart-dropdown">
                                <div className="p-3 border-top-0 border-start-0 border-end-0 border-dashed border">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h6 className="m-0 fs-16 fw-semibold"> My Cart</h6>
                                        </div>
                                        <div className="col-auto">
                                            <span className="badge bg-warning-subtle text-warning fs-13"><span className="cartitem-badge">7</span>
                                                items</span>
                                        </div>
                                    </div>
                                </div>
                                <div data-simplebar style={{ maxHeight: '300px' }}>
                                    <div className="p-2">
                                        <div className="text-center empty-cart" id="empty-cart">
                                            <div className="avatar-md mx-auto my-3">
                                                <div className="avatar-title bg-info-subtle text-info fs-36 rounded-circle">
                                                    <i className='bx bx-cart'></i>
                                                </div>
                                            </div>
                                            <h5 className="mb-3">Your Cart is Empty!</h5>
                                            <Link to="/apps-ecommerce-products" className="btn btn-success w-md mb-3">Shop Now</Link>
                                        </div>
                                        <div className="d-block dropdown-item dropdown-item-cart text-wrap px-3 py-2">
                                            <div className="d-flex align-items-center">
                                                <img src={`${adminAssetsUrl}/images/products/img-1.png`} className="me-3 rounded-circle avatar-sm p-2 bg-light" alt="user-pic" />
                                                <div className="flex-grow-1">
                                                    <h6 className="mt-0 mb-1 fs-14">
                                                        <Link to="/apps-ecommerce-product-details" className="text-reset">Branded T-Shirts</Link>
                                                    </h6>
                                                    <p className="mb-0 fs-12 text-muted">
                                                        Quantity: <span>10 x $32</span>
                                                    </p>
                                                </div>
                                                <div className="px-2">
                                                    <h5 className="m-0 fw-normal">$<span className="cart-item-price">320</span></h5>
                                                </div>
                                                <div className="ps-2">
                                                    <button type="button" className="btn btn-icon btn-sm btn-ghost-secondary remove-item-btn shadow-none"><i className="ri-close-fill fs-16"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-block dropdown-item dropdown-item-cart text-wrap px-3 py-2">
                                            <div className="d-flex align-items-center">
                                                <img src={`${adminAssetsUrl}/images/products/img-2.png`} className="me-3 rounded-circle avatar-sm p-2 bg-light" alt="user-pic" />
                                                <div className="flex-grow-1">
                                                    <h6 className="mt-0 mb-1 fs-14">
                                                        <Link to="/apps-ecommerce-product-details" className="text-reset">Bentwood Chair</Link>
                                                    </h6>
                                                    <p className="mb-0 fs-12 text-muted">
                                                        Quantity: <span>5 x $18</span>
                                                    </p>
                                                </div>
                                                <div className="px-2">
                                                    <h5 className="m-0 fw-normal">$<span className="cart-item-price">89</span></h5>
                                                </div>
                                                <div className="ps-2">
                                                    <button type="button" className="btn btn-icon btn-sm btn-ghost-secondary remove-item-btn shadow-none"><i className="ri-close-fill fs-16"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-block dropdown-item dropdown-item-cart text-wrap px-3 py-2">
                                            <div className="d-flex align-items-center">
                                                <img src={`${adminAssetsUrl}/images/products/img-3.png`} className="me-3 rounded-circle avatar-sm p-2 bg-light" alt="user-pic" />
                                                <div className="flex-grow-1">
                                                    <h6 className="mt-0 mb-1 fs-14">
                                                        <Link to="/apps-ecommerce-product-details" className="text-reset">Borosil Paper Cup</Link>
                                                    </h6>
                                                    <p className="mb-0 fs-12 text-muted">
                                                        Quantity: <span>3 x $250</span>
                                                    </p>
                                                </div>
                                                <div className="px-2">
                                                    <h5 className="m-0 fw-normal">$<span className="cart-item-price">750</span></h5>
                                                </div>
                                                <div className="ps-2">
                                                    <button type="button" className="btn btn-icon btn-sm btn-ghost-secondary remove-item-btn shadow-none"><i className="ri-close-fill fs-16"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-block dropdown-item dropdown-item-cart text-wrap px-3 py-2">
                                            <div className="d-flex align-items-center">
                                                <img src={`${adminAssetsUrl}/images/products/img-6.png`} className="me-3 rounded-circle avatar-sm p-2 bg-light" alt="user-pic" />
                                                <div className="flex-grow-1">
                                                    <h6 className="mt-0 mb-1 fs-14">
                                                        <Link to="/apps-ecommerce-product-details" className="text-reset">Gray Styled T-Shirt</Link>
                                                    </h6>
                                                    <p className="mb-0 fs-12 text-muted">
                                                        Quantity: <span>1 x $1250</span>
                                                    </p>
                                                </div>
                                                <div className="px-2">
                                                    <h5 className="m-0 fw-normal">$ <span className="cart-item-price">1250</span></h5>
                                                </div>
                                                <div className="ps-2">
                                                    <button type="button" className="btn btn-icon btn-sm btn-ghost-secondary remove-item-btn shadow-none"><i className="ri-close-fill fs-16"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-block dropdown-item dropdown-item-cart text-wrap px-3 py-2">
                                            <div className="d-flex align-items-center">
                                                <img src={`${adminAssetsUrl}/images/products/img-5.png`} className="me-3 rounded-circle avatar-sm p-2 bg-light" alt="user-pic" />
                                                <div className="flex-grow-1">
                                                    <h6 className="mt-0 mb-1 fs-14">
                                                        <Link to="/apps-ecommerce-product-details" className="text-reset">Stillbird Helmet</Link>
                                                    </h6>
                                                    <p className="mb-0 fs-12 text-muted">
                                                        Quantity: <span>2 x $495</span>
                                                    </p>
                                                </div>
                                                <div className="px-2">
                                                    <h5 className="m-0 fw-normal">$<span className="cart-item-price">990</span></h5>
                                                </div>
                                                <div className="ps-2">
                                                    <button type="button" className="btn btn-icon btn-sm btn-ghost-secondary remove-item-btn shadow-none"><i className="ri-close-fill fs-16"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="p-3 border-bottom-0 border-start-0 border-end-0 border-dashed border" id="checkout-elem">
                                    <div className="d-flex justify-content-between align-items-center pb-3">
                                        <h5 className="m-0 text-muted">Total:</h5>
                                        <div className="px-2">
                                            <h5 className="m-0" id="cart-item-total">$1258.58</h5>
                                        </div>
                                    </div>
                                    <Link to="/apps-ecommerce-checkout" className="btn btn-success text-center w-100">Checkout</Link>
                                </div>
                            </div>
                        </div> */}
                        {vendorPreviewUrl && (
                            <div className="ms-1 header-item d-flex align-items-center">
                                <Link
                                    to={vendorPreviewUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-sm btn-primary d-flex align-items-center gap-2 px-3 rounded-pill shadow-sm vendor-preview-button"
                                    title="Open public vendor profile"
                                >
                                    <i className="bi bi-eye-fill" aria-hidden="true"></i>
                                    <span className="vendor-preview-label">Live Preview</span>
                                </Link>
                            </div>
                        )}
                        <div className="ms-1 header-item d-none d-sm-flex">
                            <button type="button" onClick={toggleFullscreen} className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none" data-toggle="fullscreen">
                                <i className='bx bx-fullscreen fs-22'></i>
                            </button>
                        </div>
                        <div className="ms-1 header-item d-none d-sm-flex">
                            <button type="button" onClick={toggleDarkMode} className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle light-dark-mode shadow-none">
                                <i className='bx bx-moon fs-22'></i>
                            </button>
                        </div>
                        {/* <div className="dropdown topbar-head-dropdown ms-1 header-item" id="notificationDropdown">
                            <button type="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none" id="page-header-notifications-dropdown" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-haspopup="true" aria-expanded="false">
                                <i className='bx bx-bell fs-22'></i>
                                <span className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">3<span className="visually-hidden">unread messages</span></span>
                            </button>
                            <div className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" aria-labelledby="page-header-notifications-dropdown">
                                <div className="dropdown-head bg-primary bg-pattern rounded-top">
                                    <div className="p-3">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h6 className="m-0 fs-16 fw-semibold text-white"> Notifications </h6>
                                            </div>
                                            <div className="col-auto dropdown-tabs">
                                                <span className="badge bg-light-subtle text-body fs-13"> 4 New</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="px-2 pt-2">
                                        <ul className="nav nav-tabs dropdown-tabs nav-tabs-custom" data-dropdown-tabs="true" id="notificationItemsTab" role="tablist">
                                            <li className="nav-item waves-effect waves-light">
                                                <a className="nav-link active" data-bs-toggle="tab" href="#all-noti-tab" role="tab" aria-selected="true">
                                                    All (4)
                                                </a>
                                            </li>
                                            <li className="nav-item waves-effect waves-light">
                                                <a className="nav-link" data-bs-toggle="tab" href="#messages-tab" role="tab" aria-selected="false">
                                                    Messages
                                                </a>
                                            </li>
                                            <li className="nav-item waves-effect waves-light">
                                                <a className="nav-link" data-bs-toggle="tab" href="#alerts-tab" role="tab" aria-selected="false">
                                                    Alerts
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="tab-content position-relative" id="notificationItemsTabContent">
                                    <div className="tab-pane fade show active py-2 ps-2" id="all-noti-tab" role="tabpanel">
                                        <div data-simplebar style={{ maxHeight: '300px' }} className="pe-2">
                                            <div className="text-reset notification-item d-block dropdown-item position-relative">
                                                <div className="d-flex">
                                                    <div className="avatar-xs me-3 flex-shrink-0">
                                                        <span className="avatar-title bg-info-subtle text-info rounded-circle fs-16">
                                                            <i className="bx bx-badge-check"></i>
                                                        </span>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <a href="#!" className="stretched-link">
                                                            <h6 className="mt-0 mb-2 lh-base">Your <b>Elite</b> author Graphic Optimization <span className="text-secondary">reward</span> is ready!</h6>
                                                        </a>
                                                        <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                                            <span><i className="mdi mdi-clock-outline"></i> Just 30 sec ago</span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="dropdown ms-sm-3 header-item topbar-user">
                            <button type="button" className="btn shadow-none" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span className="d-flex align-items-center">
                                    <img className="rounded-circle header-profile-user" src={`${adminAssetsUrl}/images/users/avatar-1.jpg`} alt="Header Avatar" />
                                    <span className="text-start ms-xl-2">
                                        <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">Anna Adame</span>
                                        <span className="d-none d-xl-block ms-1 fs-12 user-name-sub-text">Founder</span>
                                    </span>
                                </span>
                            </button>
                            <div className="dropdown-menu dropdown-menu-end">
                                <h6 className="dropdown-header">Welcome Anna!</h6>
                                <Link to="/admin/profile" className="dropdown-item"><i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i> <span className="align-middle">Profile</span></Link>
                                <Link to="/admin/chat" className="dropdown-item"><i className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i> <span className="align-middle">Messages</span></Link>
                                <div className="dropdown-divider"></div>
                                <Link to="/admin/logout" className="dropdown-item"><i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span className="align-middle" data-key="t-logout">Logout</span></Link>
                            </div>
                        </div> */}
                        <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user vendor-profile-menu">
                            <DropdownToggle tag="button" type="button" className="btn shadow-none">
                                <span className="d-flex align-items-center">
                                    <img className="rounded-circle header-profile-user" // Use vendor's profile image if available, otherwise
                                        src={vendor && vendor.company_logo_path ? vendor.company_logo_path :
                                            `${adminAssetsUrl}/images/users/avatar-1.jpg`}
                                        alt={vendor?.company_name ? `${vendor.company_name} logo` : "Company profile"} />
                                    <span className="text-start ms-xl-2">
                                        <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                                            {/* Display vendor's name, or 'Guest' if not loaded */}
                                            {vendor ? vendor.name : 'Anna Adame'}
                                        </span>
                                        <span className="d-none d-xl-block ms-1 fs-12 user-name-sub-text">
                                            {/* Display vendor's role, or a default */}
                                            {vendor ? (vendor.role || 'Vendor') : 'Founder'}
                                        </span>
                                    </span>
                                </span>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                                <h6 className="dropdown-header">
                                    Welcome {vendor ? vendor.name : 'Guest'}!
                                </h6>
                                {vendor && (
                                    <>
                                        <div className="px-3 py-2 border-bottom">
                                            <p className="mb-0 fs-12 text-muted d-flex"><i className="mdi mdi-email-outline me-1"></i>{vendor.email}</p>
                                            {vendor.phone && <p className="mb-0 fs-12 text-muted"><i className="mdi mdi-phone-outline me-1"></i>{vendor.phone}</p>}
                                        </div>
                                    </>
                                )}
                                <Link to="/admin/kyc-verification" className="dropdown-item" onClick={() => setIsProfileDropdown(false)}>
                                    <i className="mdi mdi-account-cog-outline text-muted fs-16 align-middle me-1"></i>
                                    <span className="align-middle">KYC / Settings</span>
                                </Link>
                                <Link to="/admin/profile-setup" className="dropdown-item" onClick={() => setIsProfileDropdown(false)}>
                                    <i className="mdi mdi-account-cog-outline text-muted fs-16 align-middle me-1"></i>
                                    <span className="align-middle">Profile Setup</span>
                                </Link>
                                {vendorPreviewUrl && (
                                    <Link
                                        to={vendorPreviewUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="dropdown-item"
                                    >
                                        <i className="ri-building-4-line text-muted fs-16 align-middle me-1"></i>
                                        <span className="align-middle">Vendor Details</span>
                                    </Link>
                                )}
                                <div className="dropdown-divider"></div>
                                <DropdownItem onClick={(e) => { setIsProfileDropdown(false); handleLogout(e); }}>
                                    <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
                                    <span className="align-middle" data-key="t-logout">Logout</span>
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
